import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { oidcAuthApi, oidcAuthApiRef } from './apis';
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import { navModule } from './modules/nav';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { zipPasswordModule } from './modules/scaffolder/ZipPasswordModule';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        providers={[
          {
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in using GitHub',
            apiRef: githubAuthApiRef,
          },
          {
            id: 'oidc-auth-provider',
            title: 'Keycloak',
            message: 'Sign in using Keycloak',
            apiRef: oidcAuthApiRef,
          },
        ]}
      />
    ),
  },
});

export default createApp({
  features: [
    zipPasswordModule,
    catalogPlugin,
    gitlabPlugin,
    kubernetesPlugin,
    navModule,
    notificationsPlugin,
    searchPlugin,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage, oidcAuthApi],
    }),
  ]
});
